// iter137 — Phase 3 page-transition wrapper. Cross-fades + slides children
// every time the route changes, so the app feels like an Android native
// stack-navigator instead of a jumpy MPA reload. Pure CSS keyframes — no
// runtime motion lib added. Honours `prefers-reduced-motion`.
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function PageTransition({ children }) {
  const location = useLocation();
  const [phase, setPhase] = useState("in");

  useEffect(() => {
    setPhase("enter");
    const id = requestAnimationFrame(() => setPhase("in"));
    return () => cancelAnimationFrame(id);
  }, [location.pathname]);

  return (
    <div className={`page-transition page-transition--${phase}`} data-testid="page-transition">
      {children}
    </div>
  );
}
